import React from "react";
import { ThemeProvider } from "../context/ThemeContext";

const WrappedRoot = ({ element }, { plugins, ...themeOptions }) => {
  return (
    <ThemeProvider themeOptions={themeOptions}>
      {element}
    </ThemeProvider>
  );
};

export default WrappedRoot;
